import type { OfflineFeatureMode } from './types';

// Conservative initial policy: only workflows already evidenced in the source are
// allowed offline. Everything else stays ONLINE_REQUIRED until migrated through
// the Offline Kernel and accepted by its test matrix.
export const OFFLINE_FEATURE_MATRIX: Record<string, OfflineFeatureMode> = {
  READ_ASSIGNED_FARMS: 'OFFLINE_LIMITED',
  MAP_ASSIGNED_FARM: 'OFFLINE_FULL',
  CAPTURE_TRUCK_GPS: 'OFFLINE_FULL',
  READ_ASSIGNED_DISPATCH: 'OFFLINE_LIMITED',

  CREATE_FARMER: 'ONLINE_REQUIRED',
  EDIT_FARMER: 'ONLINE_REQUIRED',
  CREATE_FARM: 'ONLINE_REQUIRED',
  EDIT_FARM: 'ONLINE_REQUIRED',
  CREATE_INSPECTION: 'ONLINE_REQUIRED',
  INSPECT_HARVEST_NOTICE: 'OFFLINE_FULL',
  CREATE_PEST_REPORT: 'ONLINE_REQUIRED',
  CREATE_HARVEST_NOTICE: 'ONLINE_REQUIRED',
  CREATE_BATCH: 'ONLINE_REQUIRED',
  CAPTURE_DELIVERY: 'ONLINE_REQUIRED',
  WAREHOUSE_INTAKE: 'ONLINE_REQUIRED',
  CLERK_TRANSACTION: 'ONLINE_REQUIRED',
  CREATE_PAYMENT_INTENT: 'ONLINE_REQUIRED',
  POST_FINANCIAL_LEDGER: 'ONLINE_REQUIRED',
  APPROVE_EUDR_CASE: 'ONLINE_REQUIRED',
  ALTER_MAPPING_POLICY: 'ONLINE_REQUIRED',
  ALTER_RISK_ENGINE: 'ONLINE_REQUIRED',
  MANAGE_USERS: 'ONLINE_REQUIRED',
  MANAGE_ROLES: 'ONLINE_REQUIRED',
};

export function featureMode(action: string): OfflineFeatureMode {
  return OFFLINE_FEATURE_MATRIX[action] || 'ONLINE_REQUIRED';
}
